module.exports = __webpack_public_path__ + "media/images/emblems/Vucherens_ch-378651c9bd371e59604e9acdb1da2219.png";